import { Container, Nav, NavItem } from 'reactstrap';
import {
  athensGray,
  primaryTheme,
  sideBarHover,
  text
} from 'components/style/Colors.style';
import { NavLink } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import styled from 'styled-components';

export const MenuListContainer = styled(Container).attrs({
  className: 'pl-4 py-3'
})``;

export const MenuList = styled(Nav).attrs({
  navbar: true,
  vertical: true
})``;

export const MenuItem = styled(NavItem).attrs({
  className: 'py-1 d-flex align-content-center'
})``;

export const ChildItem = styled(NavItem).attrs({
  className: 'py-1'
})``;

export const MenuLink = styled(NavLink)`
  padding-left: 9px;
  padding-top: 9px;
  padding-bottom: 7px;
  width: 200px;
  line-height: normal;
  font-weight: medium;
  letter-spacing: 0.6px;
  color: ${text};
  display: flex;
  &:hover {
    background-color: ${athensGray};
    border-radius: 3px;
    text-decoration: none;
    svg > g > g {
      stroke: ${sideBarHover};
    }
  }
  &.active {
    fill: ${primaryTheme};
    color: ${primaryTheme};
    background-color: ${athensGray};
    border-radius: 3px;
    text-decoration: none;
    svg > g > g {
      stroke: ${primaryTheme};
    }
  }
`;

export const ChildLink = MenuLink.extend`
  padding: 0px 0px 0px 50px;
  font-weight: regular;
  background-color: none;
  &:hover,
  &.active {
    background-color: transparent;
  }
`;

export const Glyphicon = styled(SVG).attrs({
  className: 'mr-3 d-inline-block align-middle'
})`
  svg {
    width: 1rem;
    max-height: 1rem;
  }

  svg > g > g {
    stroke: ${text};
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/SideMenu/MenuList/MenuList.style.js